"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgManholeOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.manhole_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "manhole_outline_svg__transparent_box" },
            React.createElement("path", { className: "manhole_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "manhole_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "manhole_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M26 4h2v24h-2zM4 22v2h17v4h2v-6H4zM21 4v4H4v2h19V4h-2z" }))));
}
exports.default = SvgManholeOutline;
//# sourceMappingURL=ManholeOutline.js.map